import { useEffect, useState } from "react";
import HomeLayout from "./HomeLayout";
import {
  NewAndUpdatedContentSection,
  GuidelinesSection,
  AppAccessSection,
} from "./sections";
import ModernFooter from "./ModernFooter";
import useAppModernisation from "../../hooks/useAppModernisation";
import "../../scss/modernPageReset.scss";
import PasswordResetSuccessModal from "../PasswordResetSuccessModal";

const ModernHomePage = () => {
  const { isWebModernisationEnabled } = useAppModernisation();
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    if (!isWebModernisationEnabled) return;
    // check if reset password
    const showSuccess = sessionStorage.getItem("showPasswordResetSuccess");
    if (showSuccess === "true") {
      setShowSuccessModal(true);
      sessionStorage.removeItem("showPasswordResetSuccess");
    }
  }, [isWebModernisationEnabled]);

  if (!isWebModernisationEnabled) {
    // legacy implementation if modernisation is disabled
    return null;
  }
  const handleCloseModal = () => {
    setShowSuccessModal(false);
  };

  return (
    <div className="modern-page-container">
      <HomeLayout>
        <NewAndUpdatedContentSection />
        <GuidelinesSection />
        <AppAccessSection />
        <ModernFooter />
        <PasswordResetSuccessModal
          visible={showSuccessModal}
          onClose={handleCloseModal}
        />
      </HomeLayout>
    </div>
  );
};

export default ModernHomePage;
